import { strings } from '@/shared/strings';
import { PauseIcon, RedoIcon } from '@/ui/icons';
import styles from './CaseMarks.module.css';

/**
 * The marks beside a job order number: urgent, a remake, and on hold, each
 * drawn only when it applies and all of them when a case is all three. The
 * lab's request of 20 October 2026 added the hold mark, a circle like the
 * redo mark's, in the slate a hold is shown in everywhere: a stop, not an
 * alarm. Red stays urgent's alone.
 *
 * role="img" on each, because ARIA prohibits a name on a bare span and the
 * mark is the only thing on the row that says it.
 */
export function CaseMarks({
  urgent = false,
  redo = false,
  held = false,
  urgentLabel = strings.table.urgent,
}: {
  urgent?: boolean;
  redo?: boolean;
  held?: boolean;
  /** The urgent dot's name, where a screen says it in its own words. */
  urgentLabel?: string;
}) {
  return (
    <>
      {urgent && <span className={styles.urgentDot} role="img" aria-label={urgentLabel} />}
      {redo && (
        <span className={styles.redoMark} role="img" aria-label={strings.table.redo} title={strings.table.redo}>
          <RedoIcon size={13} />
        </span>
      )}
      {held && (
        <span className={styles.holdMark} role="img" aria-label={strings.table.onHold} title={strings.table.onHold}>
          <PauseIcon size={12} />
        </span>
      )}
    </>
  );
}
